import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { navigateTo } from "../../Helper"


import { App } from '@capacitor/app';

const AppUrlListener = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    App.addListener('appUrlOpen', (event) => {
      const url = event.url.split('.com').pop();
      if (url&& url !== location.pathname) {
        navigateTo(dispatch, navigate, url);
      }
    });
  }, []);

  return null;
};

export default AppUrlListener;